import React, { useContext } from 'react';
import { Card, CircularProgress, Grid, Hidden, Button, ButtonGroup } from '@material-ui/core';
import { EWIPDashboardScreenContext } from '../DashboardProvider';
import './wipDashStyle.scss';
import { WipNoRecord, WipScreenLoader } from './wipDash-Loader';

const WipDashboardDates = ({ classes, onChartClickHandler }) => {
    const { state, array, handleDate, handleChangeByTime, WipsDate, getDateObj } = useContext(EWIPDashboardScreenContext);
    return (
        <>
            {state.showHeaderLoader ? (
                <div className="wip-dash-Card">
                    <WipScreenLoader />
                </div>
            ) : (
                <Card className="wip-dash-Card">
                    <Hidden only={['xs']}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={8}>
                                <div
                                    style={{
                                        margin: '10px 10px',
                                        textAlign: 'left'
                                    }}
                                >
                                    <ButtonGroup color="secondary" ria-label="outlined primary button group" size="small">
                                        {WipsDate.map((n) => {
                                            return (
                                                <Button
                                                    key={n.name}
                                                    variant={array.assignedDate === n.id ? 'contained' : 'outlined'}
                                                    onClick={() => handleDate(n.id)}
                                                    style={{ fontSize: 10 }}
                                                >
                                                    {n.name}
                                                </Button>
                                            );
                                        })}
                                    </ButtonGroup>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <div
                                    style={{
                                        float: 'right',
                                        margin: 10
                                    }}
                                >
                                    <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}>
                                        <option value={'Default'}>All Branches</option>
                                        {state.chartdata.map((btn, i) => {
                                            return (
                                                <option key={i} value={btn.name}>
                                                    {btn.name}{' '}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </Hidden>
                    <Hidden only={['sm', 'md', 'lg', 'xl']}>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <div
                                    style={{
                                        margin: '0px 20px',
                                        textAlign: 'left'
                                    }}
                                >
                                    <span className="lableFont">Dates</span>
                                    <select
                                        color="secondary"
                                        onChange={handleDate}
                                        aria-label="outlined primary button group"
                                        size="small"
                                        className="ButtonDropDown"
                                        value={array.assignedDate}
                                    >
                                        {WipsDate.map((n, i) => {
                                            return (
                                                <option key={i} value={n.id}>
                                                    {n.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div
                                    style={{
                                        margin: '0px 20px',
                                        textAlign: 'left'
                                    }}
                                >
                                    <span className="lableFont">Branch</span>
                                    <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}>
                                        <option value={'Default'}>All Branches</option>
                                        {state.chartdata.map((btn, i) => {
                                            return (
                                                <option key={i} value={btn.name}>
                                                    {btn.name}{' '}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </Hidden>

                    <div style={{ padding: '0px 30px' }}>
                        <hr className="labeled-bordered-box" />
                    </div>
                    <Grid container spacing={1} style={{ padding: '0px 20px' }}>
                        {getDateObj.length == 0 ? (
                            <WipNoRecord />
                        ) : (
                            getDateObj.map((item, index) => (
                                <Grid
                                    item
                                    key={item.label}
                                    xs={6}
                                    sm={2}
                                    style={{ padding: '5px 5px' }}
                                    onClick={() =>
                                        onChartClickHandler(
                                            {
                                                workflowID: 'All',
                                                workflow: array.byTimeObj?.workflow,
                                                bn: array.byTimeObj?.bn,
                                                time: item.time,
                                                dueTime: item.dueTime
                                            },
                                            true
                                        )
                                    }
                                >
                                    <div
                                        style={{
                                            borderLeft: item.BarColor
                                        }}
                                        className="wip-dash-Card-content"
                                        // onClick={() => buttonClicked(m)}
                                    >
                                        <div className="wip-dash-Card-content-values">
                                            <span className="lableFont">{item.label}</span>
                                            <div className="valueFont">{item.value || 0}</div>
                                        </div>
                                    </div>
                                </Grid>
                            ))
                        )}
                    </Grid>
                </Card>
            )}
        </>
    );
};

export default WipDashboardDates;
